import React, { Component } from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

class InteractQueueDropdown extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { item, menuAnchor, handleMenuClose, t } = this.props;
		return (
			<>
				<Menu
					id="interactQueueDropDownList"
					anchorEl={menuAnchor}
					onClose={handleMenuClose}
					open={Boolean(menuAnchor)}
					getContentAnchorEl={null}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
				>
					<MenuItem className="listingMenuDropDown" key="1" onClick={() => handleMenuClose('edit', item)}>
						{t('COMMON_EDIT')}
					</MenuItem>
					<MenuItem className="listingMenuDropDown" key="2" onClick={() => handleMenuClose('delete', item)}>
						{t('COMMON_REMOVE')}
					</MenuItem>
				</Menu>
			</>
		);
	}
}

export default InteractQueueDropdown;
